import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import * as yup from 'yup';
import { withFormik } from 'formik';
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';
import { creditCardType } from './CheckFlagCard';
import axios from '../../config/axiosInstance';
import Input from '../../components/Input/Input';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import ViewDayIcon from '@material-ui/icons/ViewDay';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import CheckCircleOutlineOutlined from '@material-ui/icons/CheckCircleOutlineOutlined';
import { usageLog } from '../../store/actions/globalActions';
import { setMessage } from '../../store/actions/general';
import { useDispatch } from 'react-redux';

const PaymentByCreditCard = (props) => {
    const {
        checked,
        checkbox,
        planSelected,
        values,
        companyData,
        formValues,
        onChangeValue,
        errors,
        touched,
        handleBlur,
        handleChange,
        disabledbuttom,
        setDisabledbuttomFormCreditCard,
        creditCards
    } = props;

    const [focus, setFocus] = useState('');
    const [disable, setDisable] = useState(true);
    const [disabledLater, setDisabledLater] = useState(false);
    const [brand, setBrand] = useState('');
    const [paymentApprovedModal, setPaymentApprovedModal] = useState(false);
    const dispatch = useDispatch();

    const generateCardPayment = () => {
        setDisabledLater(true);
        // console.log('values', values)
        // console.log('companyData', companyData)
        // console.log('formValues', formValues)
        const paymentInfo = {
            idPlan: planSelected.uuidOffer,
            ticket: formValues.ticket.toUpperCase(),
            priceUser: checked ? planSelected.yearlyPrice : planSelected.monthlyPrice,
            isAnnual: checked ? true : false,
            isBillet: false,
            numberCard: values.number,
            nameOwner: values.name,
            expiryMonth: values.expiry.split('/')[0],
            expiryYear: values.expiry.split('/')[1],
            cvv: values.cvc.trim(),
            brand: brand,
            focused: focus,
            invoice: {
                businessName: formValues.name,
                cnpj: formValues.document.replace(/\D+/g, ''),
                address: formValues.address,
                email: formValues.email,
                phone: formValues.phone.replace(/\D+/g, ''),
                houseNumber: formValues.addressNumber,
                complement: formValues.complement,
                neighborhood: formValues.district,
                city: formValues.city,
                cityCod: formValues.cityCod,
                stateCod: formValues.state,
                postalCode: companyData.zipCode || formValues.zipCode,
                municipalInscription: checkbox ? 'ISENTO' : values.municipalInscription,
            },
        };
        // console.log('paymentInfo', paymentInfo)

        const companyId = JSON.parse(localStorage.getItem('companies')).find(x => x.companyId).companyId;
        const userId = JSON.parse(localStorage.getItem('companies')).find(x => x.userId).userId;
        usageLog("Assinaturas/formulario/geradoNoCartão", companyId, userId, "cardPayment");

        axios.post('/payments/paypal/create-order-card', paymentInfo)
            .then(({ result }) => {
                setPaymentApprovedModal(true)
            })
            .catch((err) => {
                // console.log('error', err)
                setPaymentApprovedModal(false)
                setDisabledLater(false);
                dispatch(setMessage(err));
            });
    };

    const creditValues = [
        {
            elementType: 'maskedInput',
            config: {
                name: 'number',
                label: 'NUMERO DO CARTÃO',
                mask: [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
            },
        },
        {
            elementType: 'input',
            config: {
                name: 'name',
                label: 'NOME',
            },
        },
        {
            elementType: 'maskedInput',
            config: {
                name: 'cvc',
                label: 'CVC',
                mask: [/\d/, /\d/, /\d/, /\d/],
            },
        },
        {
            elementType: 'maskedInput',
            config: {
                name: 'expiry',
                label: 'VÁLIDO ATÉ',
                mask: [/\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
            },
        },
    ]

    return (
        <div style={{ textAlign: 'center', padding: '20px' }}>
            <Cards
                cvc={values.cvc}
                expiry={values.expiry}
                focused={focus}
                name={values.name}
                number={values.number}
            />

            <Grid container>
                {
                    creditValues.map(field => (
                        <Grid item xs={6} style={{ paddingTop: '16px' }}>
                            <Input
                                {...field.config}
                                elementType={field.elementType}
                                value={values[field.config.name]}
                                onChange={(event) => {
                                    handleChange(event);
                                    setFocus(event.target.name)
                                    if (event.target.name == 'number') {
                                        setBrand(creditCardType(event.target.value))
                                    }
                                    if (errors && Object.keys(errors).length == 0) {
                                        setDisabledbuttomFormCreditCard(false);
                                        setDisable(false);
                                    }
                                    if (errors && Object.keys(errors).length != 0) {
                                        setDisabledbuttomFormCreditCard(true);
                                        setDisable(true);
                                    }
                                }}
                                onBlur={(event) => {
                                    handleBlur(event);
                                    if (errors && Object.keys(errors).length == 0) {
                                        setDisabledbuttomFormCreditCard(false);
                                        setDisable(false);
                                    }
                                    if (errors && Object.keys(errors).length != 0) {
                                        setDisabledbuttomFormCreditCard(true);
                                        setDisable(true);
                                    }
                                }}
                                error={errors[field.config.name] && touched[field.config.name]}
                                helperText={
                                    (touched[field.config.name] && errors[field.config.name]) || field.helperText
                                }
                                style={{ width: '90%' }}
                            />
                        </Grid>
                    ))
                }
                {!disabledLater ?
                    <div style={{ width: '100%' }}>
                        {creditCards ?
                            <Button
                                disabled={disabledbuttom || disable || disabledLater}
                                variant="contained"
                                style={{
                                    width: '100%',
                                    height: '55px',
                                }}
                                onClick={() => generateCardPayment()}
                            >
                                <ViewDayIcon style={{ marginRight: '0.25em' }} />
                                Cartão
                            </Button>
                            : ''
                        }
                    </div>
                    : !paymentApprovedModal ?
                        <div style={{
                            width: '100%',
                            textAlign: 'center',
                            backgroundColor: '#dddddd',
                            padding: '3px',
                            borderRadius: '8px',
                        }}>
                            <CircularProgress />
                        </div>
                        :
                        <div style={{
                            width: '100%',
                            textAlign: 'center',
                            backgroundColor: '#dddddd',
                            padding: '3px',
                            borderRadius: '8px',
                        }}>
                            <CheckCircleOutlineOutlined
                                style={{
                                    display: 'flex',
                                    margin: 'auto',
                                    width: '44px',
                                    height: '44px',
                                    color: 'rgb(70, 160, 69)',
                                }} />
                        </div>
                }

            </Grid >

            <Dialog open={paymentApprovedModal}>
                <CheckCircleOutlineOutlined
                    style={{
                        display: 'flex',
                        margin: '20px auto 10px auto',
                        width: '89px',
                        height: '89px',
                        color: 'rgb(70, 160, 69)',
                    }} />
                <DialogTitle style={{ textAlign: 'center' }}>Estamos processando seu pagamento</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Typography style={{ fontSize: '14px' }}>
                            Assim que ele for confirmado você receberá um e-mail e as funcionalidades do seu plano serão automaticamente liberadas.
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button component={Link} to='/' >Fechar</Button>
                </DialogActions>
            </Dialog>
        </div >
    );
};

const CreditCardFormFormik = withFormik({
    mapPropsToValues: ({ values }) => ({
        number: values.number || '',
        name: values.name || '',
        cvc: values.cvc || '',
        expiry: values.expiry || '',
    }),
    validationSchema: yup.object().shape({
        number: yup.string().required(),
        name: yup.string().required(),
        cvc: yup.string().required(),
        expiry: yup.string().required(),
    }),
})(PaymentByCreditCard);

export default CreditCardFormFormik;